import React, { Component } from 'react';
import { Modal, ButtonGroup, Button, Glyphicon, Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

export default class AddOrganizationButton extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            show: false,
            value: ""
        };
    }

    handleConfirm = () => {
        this.setState({ show: false });
        this.props.onClick(this.state.value);
    }

    handleClose = () => {
        this.setState({ show: false });
    }

    handleShow = () => {
        this.setState({ show: true });
    }

    handleChange = (e) => {
        this.setState({ value: e.target.value });
    }

    render() {
        return (
            <ButtonGroup bsSize="small" className="add-btn">
                <Button onClick={this.handleShow}>
                    <Glyphicon glyph='plus' />
                </Button>
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Body>
                        <Form className="add-organization-modal">
                            <FormGroup controlId="formName">
                                <ControlLabel>The name of the organization</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={this.state.value}
                                    placeholder="Enter name"
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <Button onClick={this.handleConfirm}>Add</Button>
                            <Button onClick={this.handleClose}>Cancel</Button>
                        </Form>
                    </Modal.Body>
                </Modal>
            </ButtonGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/AddOrganizationButton.js